import { defineStore } from 'pinia'

export const useSpaceInfoStore = defineStore('spaceInfo', {
    state: () => ({
        spaceID: '',
    }),
    getters: {
        getSpaceID: (state) => {
            return state.spaceID
        },
    },
    actions: {
        updateSpaceID(spaceID) {
            this.spaceID = spaceID
        },
        cleanSpaceID() {
            this.spaceID = ''
        },
    }
})
